export default "__VITE_ASSET__BxHFNbWj__"